import styled from 'styled-components';

export const ItemsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
	gap: 16px;
	margin-bottom: 32px;
	align-items: stretch;

	@media (max-width: 768px) {
		grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
		gap: 12px;
	}
`;

export const LoadingIndicator = styled.div`
	grid-column: 1 / -1;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 40px 20px;
	min-height: 100px;
`;
